export default {
    APP_URL: "",
    API_URL: "https://api.acerapps.io/customer-api"
}
// duplicate this file twice and name them "env.prod.ts" and "env.dev.ts" 